<template>
  <div class="section sec2" :class="{activepage:showIndex==1}">
    <div class="section-contain">
      <div class="sec-header">
        <div class="header-title">让信息服务更主动，更高效，更智能
          <!-- <span class="pointer">更多应用,敬请期待</span> -->
          </div>
      </div>
      <div class="sec-body">
        <div class="sec-item" v-for="secItem in infoServiceList" :key="secItem.title" @click="handleClick(secItem.pageId)">
          <div class="sec-item-icon">
            <img :src="secItem.imgurl" alt />
          </div>
          <div class="sec-item-detail">
            <div class="sec-item-title">
              {{secItem.title}}
              <span class="sub-title" v-if="secItem.subtitle">{{secItem.subtitle}}</span>
            </div>
            <div class="sec-item-content">{{secItem.content}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="sec-footer pointer">更多应用</div> -->
  </div>
</template>

<script>
export default {
    name: "HelloWorld",
    props: ["showIndex","infoServiceList"],
    data() {
        return {
        };
    },
    methods: {
        handleClick (id) {
            this.$router.push({
                path: '/infoService',
                query: {
                    id: id
                }
            });
        }
    },
    mounted () {
    }
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.sec-header {
  font-size: 32px;
  line-height:1;
  color: #333;
  margin-bottom: 30px;
  opacity: 0;
  transition: all 2s linear;
}

.sec-header span{
  font-size:14px;
  font-weight:bold;
  color:#55c1e7;
  position:absolute;
  top:9px;
  right:0;
}

.section-contain {
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}

.sec2 .sec-body {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  /* height: 606px; */
  height: 458px;
  /* width: 1232px; */
  width: 1172px; /* height: 606px; */
  height: 458px;
  /* width: 1232px; */
  width: 1172px;
}

.sec-body .sec-item {
  /* height: 144px;
  width: 404px; */
  height: 107px;
  width: 384px;
  background-color: #fff;
  padding: 6px 12px 9px 78px;
  position: relative;
  box-sizing: border-box;
    cursor: pointer;
}

.sec-body .sec-item:hover {
  background: #f7fafc;
}

.sec-body .sec-item .sec-item-icon {
  position: absolute;
  /* top: 18px;
  left: 16px; */
  top: 8px;
  left: 10px;
  height: 52px;
  height: 52px;
}

.sec-body .sec-item .sec-item-title {
  color: #333;
  font-size: 16px;
  line-height: 24px;
  text-align: left;
  font-weight: bold;
  margin-bottom: 10px;
}

.sec-body .sec-item .sub-title {
  display: inline-block;
  width: 84px;
  font-size: 12px;
  color: #00a0e9;
  background-color: #e5f7ff;
  border-radius: 3px;
  line-height: 20px;
  height: 20px;
  text-align: center;
  margin-left: 10px;
  /* margin-top:-2px; */
  font-weight: normal;
}

.sec-body .sec-item .sec-item-content {
  /* height: 89px;
  width: 290px; */
  height: 67px;
  width: 294px;
  letter-spacing: -1px;
  word-break: break-all;
  word-wrap: break-word;
  color: #888;
  font-size: 14px;
  line-height: 22px;
  text-align: left;
}

.sec2 .sec-footer {
  position: absolute;
  height: 46px;
  width: 216px;
  line-height: 46px;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(370px);
  border: 1px solid #55c1e7;
  border-radius: 3px;
  color: #55c1e7;
  font-size: 14px;
}

/* animations */
.activepage.sec2 .sec-header {
  animation: header 1s linear;
  animation-fill-mode: forwards;
}

.activepage.sec2 .sec-body {
  animation: body 1.2s linear 0.2s;
  animation-fill-mode: forwards;
}

.activepage.sec2 .sec-footer {
  animation: footer 1s linear 0.5s;
  animation-fill-mode: forwards;
}

@keyframes header {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes body {
  0% {
    opacity: 0;
    margin-left: 150px;
  }
  100% {
    opacity: 1;
    margin-left: 0;
  }
}

@keyframes footer {
  0% {
    transform: translateX(-50%) translateY(400px);
  }
  100% {
    transform: translateX(-50%) translateY(370px);
  }
}

/* @media screen and (max-width: 1366px)@media screen and (max-width: 1366px) {
  .section-contain {
    top: calc(50% + 20px);
  }
} */
@media screen and (max-width: 1366px){
  .section-contain {
    top: calc(50% + 40px);
  }
}
@media screen and (min-width: 1920px) {
  .sec2 .sec-body {
    height: 606px;
    width: 1232px;
  }

  .section-contain {
    top: 55%;
  }

  .sec-header {
    margin-bottom: 44px;
    /* margin-bottom: 30px; */
  }

  .sec-body .sec-item {
    height: 144px;
    width: 404px;
    padding: 16px 18px 10px 90px;
  }

  .sec-body .sec-item .sec-item-icon {
    top: 18px;
    left: 16px;
  }

  .sec-body .sec-item .sec-item-title {
    margin-bottom: 10px;
    /* margin-bottom:5px; */
  }

  .sec-body .sec-item .sec-item-content {
    height: 89px;
    width: 290px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homePage/secondPage.vue